/**
 * ChatEmptyState.tsx
 *
 * Empty state placeholder when no chat is selected.
 * Extracted from ChatWrapper.v2.tsx.
 */

import { FC } from "react"
import { toAbsoluteUrl } from "src/resources/helpers"

type ChatEmptyStateProps = {
  title?: string
  description?: string
  hint?: string
}

const ChatEmptyState: FC<ChatEmptyStateProps> = ({
  title = "7Days Chat",
  description = "Handle send and receive messages from all customer on other marketplaces.",
  hint = "please select chat to start handle chat",
}) => {
  return (
    <div className="d-flex flex-column row-gap-5 h-100 w-100 p-0 m-0 align-items-center justify-content-center">
      <img
        width={150}
        height={150}
        src={toAbsoluteUrl("/media/illustrations/sketchy-1/AssetPwEntry.png")}
        alt="icon"
      />
      <div className="d-flex flex-column align-items-center justify-content-center">
        <p className="text-muted fs-2 fw-bolder p-0 m-0">{title}</p>
        <p className="text-muted fs-6 p-0 m-0 w-75 text-center pt-2">
          {description}
        </p>
      </div>
      <div className="d-flex flex-column align-items-center justify-content-center fw-bolder">
        <p className="text-muted fs-6 p-0 m-0 text-center pt-2">
          ⓘ {hint}
        </p>
      </div>
    </div>
  )
}

export default ChatEmptyState
